<section class="logo" [routerLink]="'/'">
  <span class="logo-text">Logo</span>
</section>